module.exports = __webpack_public_path__ + "static/media/telegram-logo.be3b621b.svg";